import {
  Component, OnInit
} from '@angular/core';
import {Http} from '@angular/http';
import {environment} from '../../environments/environment';
import 'rxjs/add/observable/combineLatest';

declare var slideImages: any;

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})


export class SliderComponent implements OnInit {
  public images: any;
  path = environment.path;
  start = false;

  changer: any;
  container: any;

  constructor(private http: Http) {
  }

  ngOnInit() {
    this.http.get('/assets/includes/slider.php').subscribe(s => {
      this.images = s.json();
      this.start = true;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/slider/slider.component.ts